// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/So_AdditionalServiceFiscalSalvarResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /so/additional_service_fiscal/salvar
 *
 * Returns the persisted row (create or update).
 */
import type { So_AdditionalServiceFiscalRow } from './So_AdditionalServiceFiscalRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type So_AdditionalServiceFiscalSalvarResponseDados = So_AdditionalServiceFiscalRow;

export type So_AdditionalServiceFiscalSalvarResponse = ApiResponse<So_AdditionalServiceFiscalSalvarResponseDados>;

registerResponseContract('So_AdditionalServiceFiscalSalvarResponse', {
  so_additional_service_fiscal_id:                         { type: 'number',  required: true },
  so_additional_service_fiscal_additional_service_id:      { type: 'number',  required: true },
  so_additional_service_fiscal_franchise_id:               { type: 'number',  required: false },
  so_additional_service_fiscal_lc116_code:                 { type: 'string',  required: false },
  so_additional_service_fiscal_municipal_service_code:     { type: 'string',  required: false },
  so_additional_service_fiscal_iss_aliquota:               { type: 'number',  required: false },
  so_additional_service_fiscal_iss_retido_default:         { type: 'number',  required: false },
  so_additional_service_fiscal_municipio_incidencia_ibge:  { type: 'string',  required: false },
  so_additional_service_fiscal_cnae:                       { type: 'string',  required: false },
  so_additional_service_fiscal_codigo_tributacao_nacional: { type: 'string',  required: false },
})
